module.exports = __webpack_public_path__ + "img/37.53c74d1b.png";